<template>
    <div>
        <div class="banner">
            <div class="headerReplacementInformation"></div>
            <div class="banner-text">
                <b>รับอีเมลข่าวสาร</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span>สอบถามข้อมูล</span>
                    <span class="separator"></span>
                    <span><b>รับอีเมลข่าวสาร</b></span>
                </div>
            </div>
        </div>

        <div class="container mb-5">
            <div class="TabMenu mb-5">
                <InformationTabMenu />
            </div>
            <div class="text-center mb-5">
                <h4 class="fw-bold">ท่านสามารถลงทะเบียนเพื่อรับข่าวสารอิเล็กทรอนิกส์ เราจะส่งข่าวสารให้ท่านทาง อีเมล์</h4>
                <div>เมื่อมีข่าวสารที่เกี่ยวกับบริษัท (ประกาศ, ปรับปรุงเว็บไซต์) ที่ประกาศผ่านเว็บไซต์นี้</div>
                <div>เพื่อลงทะเบียนรับข้อมูลข่าวสารอิเล็กทรอนิกส์กรุณากรอกรายละเอียด ของท่านและคลิกปุ่ม
                    “สมัครสมาชิกรับข่าวสาร”</div>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-10">
                    <div class="card border border-0 rounded-0 p-3">
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">ชื่อ-นามสกุล</label>
                                    <input v-model="form.fullName" type="text" class="form-control" placeholder="กรอกชื่อ">
                                    <span v-if="errorMessage.fullName" class="text-danger">{{ errorMessage.fullName
                                    }}</span>
                                </div>
                                <div class="col-md">
                                    <label class="form-label">อีเมล*</label>
                                    <input v-model="form.email" type="email" class="form-control" placeholder="กรอกอีเมล">
                                    <span v-if="errorMessage.email" class="text-danger">{{ errorMessage.email }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">ประเทศ</label>
                                    <input v-model="form.country" type="text" class="form-control"
                                        placeholder="เลือกประเทศ">
                                    <span v-if="errorMessage.country" class="text-danger">{{ errorMessage.country }}</span>

                                </div>
                                <div class="col-md">
                                    <label class="form-label">อาชีพ</label>
                                    <input v-model="form.occupation" type="text" class="form-control" placeholder="อาชีพ">
                                    <span v-if="errorMessage.occupation" class="text-danger">{{ errorMessage.occupation
                                    }}</span>
                                </div>
                            </div>
                            <div class="row mb-5">
                                <div class="col-md">
                                    <label class="form-label">ตำแหน่งงาน</label>
                                    <input v-model="form.jobTitle" type="text" class="form-control"
                                        placeholder="ตำแหน่งงาน">
                                    <span v-if="errorMessage.jobTitle" class="text-danger">{{ errorMessage.jobTitle
                                    }}</span>
                                </div>
                                <div class="col-md">
                                    <label class="form-label">อุตสาหกรรม</label>
                                    <input v-model="form.industry" type="text" class="form-control"
                                        placeholder="อุตสาหกรรม">
                                    <span v-if="errorMessage.industry" class="text-danger">{{ errorMessage.industry
                                    }}</span>
                                </div>
                            </div>
                            <div class="d-grid gap-2 col-4 mx-auto">
                                <button @click="subscribeToEmails" class="btn btn-primary"
                                    type="button">สมัครรับข่าวสาร</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center mt-5">
                หากท่านต้องการยกเลิกข่าวสารอิเล็กทรอนิกส์จาก บริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน)
                <span @click="openModal" class="text-reemail">โปรดคลิกที่นี่</span>
            </div>

            <!-- Modal -->
            <div v-if="showModal" class="modal fade show" tabindex="-1" style="display: block;" aria-modal="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div class="text-center m-3">
                                <h5>ยินดีต้อนรับเข้าสู่การบริการข่าวสารอิเล็กทรอนิกส์ </h5>
                                <h5>จากบริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน)</h5>
                            </div>
                            <div class="text-center m-3">
                                <small>กรุณากรอกชื่ออีเมลของท่าน เพื่อยกเลิกการรับข้อมูลข่าวสารอิเล็กทรอนิกส์</small>
                            </div>
                            <label class="form-label">อีเมล*</label>
                            <input v-model="modalEmail" type="email" class="form-control"
                                placeholder="กรอกอีเมลเพื่อยกเลิก">
                            <span v-if="errorMessage.modalEmail" class="text-danger">{{ errorMessage.modalEmail }}</span>
                            <div class="text-center m-3">
                                <button type="button" class="m-1 btn btn-primary"
                                    @click="unsubscribeEmail">ยกเลิกรับข่าวสาร</button>
                                <button type="button" class="m-1 btn btn-secondary" @click="closeModal">ปิด</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Modal -->

        </div>
    </div>
</template>

<script>
import InformationTabMenu from '@/components/InformationTabMenu.vue';
import { GET_RECEIVE_EMAIL_INVESTOR, GET_CANCEL_EMAIL_INVESTOR } from "../../store/actions.type";
import store from "@/store";
import Swal from "sweetalert2/src/sweetalert2.js";

export default {
    name: 'Info',
    components: {
        InformationTabMenu,
    },
    data() {
        return {
            form: {
                fullName: '',
                email: '',
                country: '',
                occupation: '',
                jobTitle: '',
                industry: ''
            },
            errorMessage: {},
            showModal: false,  // Data property to control modal visibility
            modalEmail: '',    // Data property to store email for unsubscription
        };
    },
    methods: {
        validateForm(form) {
            let errors = {};

            // Validate fullName
            if (!form.fullName) {
                errors.fullName = "กรุณากรอกชื่อ-นามสกุล";
            }

            // Validate email
            if (!form.email || !/\S+@\S+\.\S+/.test(form.email)) {
                errors.email = "กรุณากรอกอีเมลที่ถูกต้อง";
            }

            // Validate country
            if (!form.country) {
                errors.country = "กรุณากรอกประเทศ";
            }

            // Validate occupation
            if (!form.occupation) {
                errors.occupation = "กรุณากรอกอาชีพ";
            }

            // Validate jobTitle
            if (!form.jobTitle) {
                errors.jobTitle = "กรุณากรอกตำแหน่งงาน";
            }

            // Validate industry
            if (!form.industry) {
                errors.industry = "กรุณากรอกอุตสาหกรรม";
            }

            return Object.keys(errors).length > 0 ? errors : null;
        },

        async subscribeToEmails() {
            // Validate the form before submitting
            let errorMessage = this.validateForm(this.form);

            if (errorMessage) {
                this.errorMessage = errorMessage;
                return;
            } else {
                this.errorMessage = {};
            }

            let form = {
                fullName: this.form.fullName,
                email: this.form.email,
                country: this.form.country,
                occupation: this.form.occupation,
                jobTitle: this.form.jobTitle,
                industry: this.form.industry,
            };

            try {
                let response = await store.dispatch(GET_RECEIVE_EMAIL_INVESTOR, form);

                if (response === 'Subscription request sent successfully') {
                    Swal.fire({
                        text: 'คุณได้รับการสมัครรับข่าวสารเรียบร้อยแล้ว',
                        icon: 'success',
                        confirmButtonColor: "#E87D2E",
                        confirmButtonText: 'ตกลง',
                        customClass: {
                            confirmButton: "btn-primary"
                        }
                    });
                    this.form = "";  // Reset form fields
                } else {
                    Swal.fire({
                        text: 'มีปัญหาในการสมัครสมาชิก กรุณาลองใหม่อีกครั้ง',
                        icon: 'error',
                        confirmButtonColor: "#E87D2E",
                        confirmButtonText: 'ตกลง',
                        customClass: {
                            confirmButton: "btn-primary"
                        }
                    });
                }
            } catch (error) {
                Swal.fire({
                    text: 'เกิดข้อผิดพลาดในการสมัครสมาชิก กรุณาลองใหม่ในภายหลัง',
                    icon: 'error',
                    confirmButtonColor: "#E87D2E",
                    confirmButtonText: 'ตกลง',
                    customClass: {
                        confirmButton: "btn-primary"
                    }
                });
            }
        },

        // Method to open the modal
        openModal() {
            this.showModal = true;
        },

        // Method to close the modal
        closeModal() {
            this.showModal = false;
        },

        // Method to handle unsubscribe action
        unsubscribeEmail() {
            // Validate the email
            if (!this.modalEmail || !/\S+@\S+\.\S+/.test(this.modalEmail)) {
                this.errorMessage.modalEmail = "กรุณากรอกอีเมลที่ถูกต้อง";
                return;
            } else {
                this.errorMessage.modalEmail = '';
            }

            // Prepare the form data for unsubscription
            const form = { email: this.modalEmail };

            // Call the store action to unsubscribe the email
            store.dispatch(GET_CANCEL_EMAIL_INVESTOR, form)
                .then(response => {
                    // Handle the response from the server
                    if (response === 'Unsubscription request sent successfully') {
                        Swal.fire({
                            text: 'คุณได้ยกเลิกการสมัครรับข่าวสารเรียบร้อยแล้ว',
                            icon: 'success',
                            confirmButtonColor: "#E87D2E",
                            confirmButtonText: 'ตกลง',
                            customClass: {
                                confirmButton: "btn-primary"
                            }
                        });
                        this.modalEmail = '';  // Reset modal email field
                        this.closeModal();  // Close the modal
                    } else {
                        Swal.fire({
                            text: 'มีปัญหาในการยกเลิกการสมัครสมาชิก กรุณาลองใหม่อีกครั้ง',
                            icon: 'error',
                            confirmButtonColor: "#E87D2E",
                            confirmButtonText: 'ตกลง',
                            customClass: {
                                confirmButton: "btn-primary"
                            }
                        });
                    }
                })
                .catch(error => {
                    Swal.fire({
                        text: 'เกิดข้อผิดพลาดในการยกเลิกการสมัครสมาชิก กรุณาลองใหม่ในภายหลัง',
                        icon: 'error',
                        confirmButtonColor: "#E87D2E",
                        confirmButtonText: 'ตกลง',
                        customClass: {
                            confirmButton: "btn-primary"
                        }
                    });
                });
        }

    }
};
</script>

<style scoped>
.text-reemail {
    color: #E87D2E;
    cursor: pointer;
}

h2.mt-5 {
    display: inline-block;
    border-bottom: 3px solid #E87D2E;
    padding-bottom: 5px;
}

.card-pdf {
    box-shadow: 0px 4px 10px 0px #0000000D;
    border: none;
}

.card {
    background-color: #F2F2F2;
}

.vertical-line {
    width: 4px;
    background-color: #E87D2E;
    margin-left: 30px;
    height: 40%;
    margin-top: 10px;
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.text-danger {
    font-size: 12px;
    color: red;
}

.modal {
    z-index: 1050;
    /* Ensure modal is on top */
}
</style>
